import { buttonProps } from './button'

import type { ExtractPropTypes } from 'vue'

export const buttonGroupProps = {
  /**
   * @description control the size of buttons in this button-group
   */
  size: buttonProps.size,
  /**
   * @description control the type of buttons in this button-group
   */
  type: buttonProps.type,
  /**
   * @description control the layout direction of buttons in this button-group
   */
  direction: {
    type: String,
    values: ['horizontal', 'vertical'] as const,
    default: 'horizontal',
  },
  /**
   * @description spacing between buttons in vertical layout (in pixels)
   */
  spacing: {
    type: Number,
    default: 8,
  },
} as const
export type ButtonGroupProps = ExtractPropTypes<typeof buttonGroupProps>
